
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import MembershipProgramForm from '@/components/navigation/MembershipProgramForm.vue';
import AvailableDiscountsBanner from '@/components/shared/AvailableDiscountsBanner.vue';

@Component<MenuResultsHeader>({
	components: {
		MembershipProgramForm,
		AvailableDiscountsBanner
	}
})
export default class MenuResultsHeader extends Vue {
	@Prop({ type: Object, required: false, default: () => {} }) private element!: Menu | MenuGroup;
	@Prop({ type: String, required: false, default: '' }) private restaurantDisplayName!: string;
	@Prop({ type: String, required: false, default: '' }) private restaurantImage!: string;
	@Prop({ type: String, required: false, default: '' }) private imageUrl!: string;
	@Getter('getRestaurantMembershipCustomization', { namespace: 'restaurant' }) private membershipCustomization!: MembershipCustomization;
	@Getter('isMembershipProgramOn', { namespace: 'restaurant' }) private isMembershipProgramOn!: string[] | string;
	@Getter('showDiscountsBanner', { namespace: 'cart' }) private showDiscountsBanner!: boolean;
}
